"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _HydrationContext = require("../BaseProvider/HydrationContext");
const isSSR = typeof window === 'undefined';
const noop = () => {};

/**
 * useSafeLayoutEffect is a alternative to useLayoutEffect that avoids SSR hydration problems:
 *  - In a client-side render, it uses useLayoutEffect to avoid flashing the pre-render UI to the user.
 *  - During hydration from SSR, the provided function is skipped to avoid mismatches from server content.
 *  - In SSR, it is a no-op function to avoid warnings about using useLayoutEffect in SSR
 */
const useSafeLayoutEffect = isSSR ? noop // avoid React's fussy warnings by ensuring to never call useLayoutEffect on server
: function (fn) {
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const isHydrating = (0, _HydrationContext.useHydrationContext)();

  // Callback updates and effect re-runs when deps array content changes, like useEffect.
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  const callback = (0, _react.useCallback)(fn, deps);
  (0, _react.useLayoutEffect)(() => {
    // Do nothing before hydrating server-generated content, like useEffect. When hydration completes,
    // useHydrationContext provides false, re-rendering this hook and re-running the effect.
    if (isHydrating) return noop;
    // If there's no hydration in progress, behave like useLayoutEffect.
    return callback();
  }, [isHydrating, callback]);
};
var _default = exports.default = useSafeLayoutEffect;